var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M12.3,17.6l-4.1-4.2c-0.1,0-0.2-0.1-0.3,0l-0.2,0.2c-0.6,2.8,0.4,5.7,2.7,7.5c1.3,1.1,3,1.7,4.7,1.7 c1,0,2-0.2,2.9-0.6l14.4,14.4c1.3,1,3.2,0.7,4.2-0.6c0.8-1.1,0.8-2.5,0-3.6L22.2,18c0.3-0.8,0.5-1.6,0.5-2.4 c0.2-2.2-0.6-4.4-2.2-5.9c-1.8-1.8-4.4-2.6-6.9-2c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.1,0,0.2,0,0.3l4.2,4.1c0.3,0.4,0.3,0.9,0,1.3l-4,4 C13.2,17.9,12.7,17.9,12.3,17.6z M36.2,32.8c0.8,1,0.8,2.4,0,3.4c-1,0.9-2.4,0.9-3.4,0L18.6,21.9l1.3-0.8c0.8-0.7,1.5-1.5,2-2.5 L36.2,32.8z M14.1,18l3.9-3.9c0.6-0.6,0.6-1.6,0-2.2l-3.6-3.7c2.1-0.2,4.2,0.5,5.7,2c1.4,1.4,2.1,3.3,2,5.3s-1.1,3.8-2.6,5.1 c-2.6,2-6.1,2-8.7,0c-1.9-1.5-2.9-3.8-2.6-6.2l3.7,3.6C12.5,18.6,13.5,18.6,14.1,18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.2,14.4c-0.3,2.4,0.7,4.7,2.6,6.2c2.6,2,6.1,2,8.7,0c1.5-1.3,2.5-3.1,2.6-5.1s-0.6-3.9-2-5.3 c-1.5-1.5-3.6-2.2-5.7-2l3.6,3.7c0.6,0.6,0.6,1.6,0,2.2L14.1,18c-0.6,0.6-1.6,0.6-2.2,0L8.2,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19.9,21.1l-1.3,0.8l14.2,14.3c1,0.9,2.4,0.9,3.4,0c0.8-1,0.8-2.4,0-3.4L21.9,18.6 C21.4,19.6,20.7,20.4,19.9,21.1z M32.2,32.2c0.5-0.5,1.2-0.5,1.7,0l1.4,1.3c0.4,0.5,0.4,1.2,0,1.7c-0.2,0.2-0.5,0.3-0.8,0.3 s-0.6-0.1-0.9-0.3l-1.4-1.4C31.8,33.3,31.8,32.7,32.2,32.2L32.2,32.2z M23.4,21.4l8.2,8.2c0.3,0.3,0.4,0.7,0.4,1.1s-0.1,0.7-0.4,1 s-0.6,0.4-1,0.4s-0.7-0.1-1-0.4l-8.3-8.2c-0.2-0.3-0.4-0.7-0.4-1.1s0.2-0.7,0.4-1c0.3-0.3,0.7-0.4,1.1-0.4S23.1,21.1,23.4,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.2,33.8l1.4,1.4c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.8-0.3c0.4-0.5,0.4-1.2,0-1.7l-1.4-1.3 c-0.5-0.5-1.2-0.5-1.7,0l0,0C31.8,32.7,31.8,33.3,32.2,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.9,22.4c0,0.4,0.2,0.8,0.4,1.1l8.3,8.2c0.3,0.3,0.6,0.4,1,0.4s0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1 s-0.1-0.8-0.4-1.1l-8.2-8.2c-0.3-0.3-0.6-0.4-1-0.4s-0.8,0.1-1.1,0.4C21.1,21.7,20.9,22,20.9,22.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.650ae60f5937a8a8f4b0084b14232297.svg";
export { ForwardRef as ReactComponent };